import React, { createContext, useContext, useId, useRef } from "react";
import type { FC, PropsWithChildren } from "react";

import type { ICoreInputTextSimpleProps } from "../types";

interface IUseStoreOptions extends Pick<ICoreInputTextSimpleProps, "state"> {}

const useStore = (options: IUseStoreOptions) => {
    const hintRef = useRef<HTMLLabelElement>(null);

    const inputId = useId();
    const hintId = useId();

    const isHintExisted = () => {
        return Boolean(hintRef.current);
    };

    return {
        state: options.state,
        hintRef,
        inputId,
        hintId,
        isHintExisted,
    };
};

const Context = createContext({} as ReturnType<typeof useStore>);

interface ICoreInputTextProvider extends PropsWithChildren, IUseStoreOptions {}

export const CoreInputTextProvider: FC<ICoreInputTextProvider> = ({
    children,
    ...options
}) => {
    const value = useStore(options);
    // eslint-disable-next-line ok-custom-rules/check-attribute
    return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useCoreInputTextStore = () => useContext(Context);
